import currencyFormatter from 'currency-formatter';

interface IOptions {
  precision: number;
}

export default function toCurrency(value: number, options?: IOptions): string {
  return currencyFormatter.format(value, { locale: 'pt-BR', code: 'BRL', ...options });
}
